import { Button, Card, Flex } from 'antd';
import { FiX } from 'react-icons/fi';

import { colorForKey } from '@utils/objectColor';
import ColorDot from '@components/modal/objectPickerModal/ColorDot';
import BaseText from '@components/typography/BaseText';

const PATH_SEPARATOR = ' › ';

/**
 * One object in a collection: colour square, label and ancestor path. Used by
 * the details panel and the builder's picked list; pass `onRemove` for the ×.
 *
 * @param {{ key: string, label: string, color?: string, path: string[] }} props.object
 * @param {(key: string) => void} [props.onRemove]
 */
const ObjectRow = ({ object, onRemove }) => {
	const path = object.path.join(PATH_SEPARATOR);

	return (
		<Card size="small">
			<Flex align="center" gap="small">
				<ColorDot color={object.color ?? colorForKey(object.key)} aria-hidden />
				<Flex vertical flex={1} style={{ minWidth: 0 }}>
					<BaseText size="sm" ellipsis>
						{object.label}
					</BaseText>
					{path && (
						<BaseText size="xs" type="secondary" ellipsis>
							{path}
						</BaseText>
					)}
				</Flex>
				{onRemove && (
					<Button
						type="text"
						size="small"
						icon={<FiX />}
						aria-label={`Remove ${object.label}`}
						onClick={() => onRemove(object.key)}
					/>
				)}
			</Flex>
		</Card>
	);
};

export default ObjectRow;
